export enum CustomerTypeEnum {
  Default = 'default',
  Bodium = 'bodium',
}

export enum CustomerCreatorEnum {
  GETLUXE = 'getluxe',
  AGENT = 'agent',
}
